import { useTranslation } from "react-i18next";
import "./Skills.css";

const CATEGORY_KEYS = ["professional", "engineering", "other"];

const Skills = () => {
    const { t } = useTranslation();

    return (
        <main className="Skills border-shadow w-50 m-a">
            <h1>{t("skills.title")}</h1>
            <div className="skillGrid">
                {CATEGORY_KEYS.map((category) => {
                    const items = t(`skills.${category}.items`, { returnObjects: true });
                    return (
                        <section key={category}>
                            <h2>{t(`skills.${category}.title`)}</h2>
                            <ul>{items.map((item) => <li key={item}>{item}</li>)}</ul>
                        </section>
                    );
                })}
            </div>
            <section className="languageSkills">
                <h2>{t("languages.title")}</h2>
                <ul>
                    <li>{t("languages.finnish")}</li>
                    <li>{t("languages.english")}</li>
                </ul>
            </section>
        </main>
    );
};
export default Skills;
